<template>
  <div class="auto-comp-container" v-if="autoComponentType">
    <div class="auto-comp" @click="$emit('click', $event)">
      <div :class="['auto-comp-icon', iconContainerClass]">
        <i :class="['fas', 'fa-fw', iconClass]"></i>
      </div>
      <div class="auto-comp-info">
        <div class="title">{{formatLookupName(autoComponentType.type, AutomationComponentTypeLookup)}}: {{autoComponentType.name}}</div>
        <div class="description automation-field-description">{{autoComponentType.description}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { AutomationComponentTypeLookup } from '@/store/types'

export default {
  name: 'AutomationComponentType',
  props: {
    autoComponentType: Object
  },
  created() {
    this.AutomationComponentTypeLookup = AutomationComponentTypeLookup
  },
  computed: {
    iconContainerClass() {
      return `auto-comp-${this.autoComponentType.type}`      
    },
    iconClass() {
      return this.autoComponentType.icon
    }
  }

}
</script>